<app-walkthrough-slide>
  <div copy class="wt-eyebrow">{{ 'app.pages.auth.walkthrough.pane8.eyebrow' | translate }}</div>
  <h2 copy class="wt-h2">{{ 'app.pages.auth.walkthrough.pane8.title' | translate }}</h2>
  <p copy class="wt-p">{{ 'app.pages.auth.walkthrough.pane8.body' | translate }}</p>

  <div copy class="wt-bul">
    <div class="wt-bul__i">
      <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane8.bullet.nothingToConfigure' | translate }}</span>
    </div>
    <div class="wt-bul__i">
      <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane8.bullet.turnOn' | translate }}</span>
    </div>
    <!-- The one bullet that is a promise rather than a fact — different glyph,
         different colour, and named as an exception. -->
    <div class="wt-bul__i wt-bul__i--soon">
      <ion-icon name="sparkles" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane8.bullet.ai' | translate }}</span>
    </div>
  </div>

  <!-- The ladder. Two columns, and the Later column restyles its rows by
       DESCENDANT selector — the rows carry no modifier of their own, exactly as
       the source has it, so a row can move between columns without editing it. -->
  <div viz class="vtl">
    <div class="vtl__c">
      <div class="vtl__h">{{ 'app.pages.auth.walkthrough.pane8.today.heading' | translate }}</div>
      @for (item of today; track item.labelKey) {
        <div class="vtl__i">
          <ion-icon [name]="item.icon" aria-hidden="true"></ion-icon>
          <span>{{ item.labelKey | translate }}</span>
        </div>
      }
    </div>
    <div class="vtl__c vtl__c--later">
      <div class="vtl__h">{{ 'app.pages.auth.walkthrough.pane8.later.heading' | translate }}</div>
      @for (item of later; track item.labelKey) {
        <div class="vtl__i">
          <ion-icon [name]="item.icon" aria-hidden="true"></ion-icon>
          <span>{{ item.labelKey | translate }}</span>
        </div>
      }
    </div>
  </div>

  <!-- The quoted prompt. Two keys — a bold lead and the sentence — because the
       lead is the label and the sentence is the example, and French punctuates
       the lead differently (`L'IA, bientôt :`, with its space before the colon). -->
  <div viz class="vprompt">
    <!-- `&ngsp;` and not a newline: Angular's default `preserveWhitespaces:
         false` deletes whitespace-only text nodes, and the space between the
         lead and the sentence is the source's, not the template's. Without it
         a reader gets `AI, coming next:“Make a claim form…`. -->
    <b>{{ 'app.pages.auth.walkthrough.pane8.prompt.lead' | translate }}</b>&ngsp;<span>{{
      'app.pages.auth.walkthrough.pane8.prompt.example' | translate
    }}</span>
  </div>
</app-walkthrough-slide>
